<template>
  <div class="page-error">
    <component :is="errorPage" :error="error" />
  </div>
</template>

<script>
import error404 from '~/components/error/404.vue';
import error500 from '~/components/error/500.vue';

export default {
  name: 'error-page',
  props: ['error'],
  layout: 'errorLayout',
  computed: {
    errorPage() {
      console.log(this.error);
      if (
        this.error &&
        this.error.statusCode >= 400 &&
        this.error.statusCode <= 499
      ) {
        return error404;
      }
      // catch everything else
      return error500;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-error {
  min-height: 400px;

}
.container {
  text-align: center;
}

#page-404 img {
  max-width: 300px;
}
</style>
